<template>
  <div>
    <a-card :bordered="false" v-if="!isAddVisible">
      <!-- 搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="6" :md="8" :sm="24">
              <a-form-item label="创建人：">
                <a-select
                  v-model="queryParam.createBy"
                  placeholder="请选择创建人"
                  allowClear
                >
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option
                    v-for="(item, index) in createByList"
                    :key="index"
                    :value="item"
                  >
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="6" :md="8" :sm="24">
              <a-form-item label="选择日期：">
                <a-range-picker
                  :value="createValue"
                  @change="rangePickerChange"
                />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="6" :md="8" :sm="24">
              <a-form-item label="宣传产品：">
                <a-input
                  v-model="screen.fundName"
                  allowClear
                  placeholder="请输入宣传产品"
                />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="6" :md="8" :sm="24">
              <span
                style="float: left;overflow: hidden;"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button @click="handleAdd" type="primary" icon="plus"
          >创建产品宣传页</a-button
        >
        <a-button type="primary" icon="delete" @click="batchDel"
          >批量删除</a-button
        >
      </div>

      <!-- table区域-begin -->
      <div>
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="pubPageList"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange
          }"
          @change="handleTableChange"
        >
          <!-- 字符串超长截取省略号显示-->
          <span slot="pageUrl" slot-scope="text">
            <j-ellipsis :value="text" :length="25" />
            <a-button
              class="tag-read"
              title="复制"
              :data-clipboard-text="text"
              @click="onCopy"
              :size="size"
              type="button"
              icon="copy"
            ></a-button>
          </span>
          <template slot="status" slot-scope="text, record">
            <a-switch
              v-model="record.statusBl"
              checked-children="启用"
              un-checked-children="禁用"
              @click="handleShelve(record)"
            />
          </template>
          <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record.id)">编辑</a>&nbsp;
            <a @click="handleDelete(record.id)">删除</a>
          </span>
        </a-table>
      </div>
    </a-card>
    <addPage
      ref="addModal"
      v-if="isAddVisible"
      @handelCancel="handelCancel"
    ></addPage>
  </div>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import JEllipsis from '@/components/jeecg/JEllipsis';
import Clipboard from 'clipboard';
import addPage from './moudel/pageAdd.vue';
import {
  deleteAction,
  getAction,
  downFile,
  getFileAccessHttpUrl,
  postAction
} from '@/api/manage';

export default {
  name: 'PubPageList',
  mixins: [JeecgListMixin],
  components: {
    JEllipsis,
    addPage
  },
  data() {
    return {
      isAddVisible: false,
      description: '宣传页面',
      test: true,
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '标题',
          align: 'center',
          dataIndex: 'title'
        },
        {
          title: '宣传产品',
          align: 'center',
          dataIndex: 'fundName'
        },
        {
          title: '创建人',
          align: 'center',
          dataIndex: 'createBy'
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime'
        },
        {
          title: '宣传页链接',
          align: 'center',
          dataIndex: 'pageUrl',
          scopedSlots: { customRender: 'pageUrl' }
        },
        {
          ellipsis: true,
          title: '启用状态',
          align: 'center',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: process.env.VUE_APP_CMS_CONTENT + '/cont/pubpage/list',
        delete: process.env.VUE_APP_CMS_CONTENT + '/cont/pubpage/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_CONTENT + '/cont/pubpage/deleteBatch',
        createByList:
          process.env.VUE_APP_CMS_CONTENT + '/cont/pubpage/createByList'
      },
      size: 'small',
      screenVisible: false,
      screen: {
        createBy: '',
        type: '',
        title: '',
        fundName: '',
        startTime: '',
        endTime: ''
      },
      pubPageList: [],
      createValue: [],
      createByList: []
    };
  },
  computed: {},
  created() {
    this.loadData();
    getAction(this.url.createByList, {}).then(res => {
      if (res.success) {
        this.createByList = res.result;
      }
    });
  },
  methods: {
    handelCancel() {
      this.isAddVisible = false;
    },
    loadData(arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!');
        return;
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      let sqp = {};
      var params = Object.assign(sqp, this.screen, this.isorter, this.filters);
      params.pageNo = this.ipagination.current;
      params.pageSize = this.ipagination.pageSize;
      this.loading = true;
      getAction(this.url.list, params).then(res => {
        if (res.success) {
          this.pubPageList = res.result.records;
          this.pubPageList.forEach((item, index) => {
            (item.statusBl = item.status == '0' ? true : false),
              (item.key = index + 1);
          });
          this.ipagination.total = res.result.total;
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
        this.loading = false;
      });
    },
    // 跳转到新建文章页面
    handleAdd() {
      // this.$refs.addForm.initData();
      this.isAddVisible = true;
      // this.$router.push('/contentManage/leaflet/moudel/pageAdd');
    },
    getList() {
      this.loadData(1);
      this.screenVisible = false;
    },
    searchReset() {
      this.screenVisible = true;
      this.screen.createBy = '';
      this.screen.title = '';
      this.screen.startTime = '';
      this.screen.endTime = '';
      this.screen.fundName = '';
      this.createValue = [];
    },
    onCopy() {
      var clipboard = new Clipboard('.tag-read');
      clipboard.on('success', e => {
        console.log('复制成功');
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', e => {
        // 不支持复制
        console.log('该浏览器不支持自动复制');
        // 释放内存
        clipboard.destroy();
      });
    },

    //批量删除
    batchDel: function() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            that.loading = true;
            deleteAction(that.url.deleteBatch, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },
    rangePickerChange(date, dateStrings) {
      this.createValue = date;
      this.screen.startTime = dateStrings[0];
      this.screen.endTime = dateStrings[1];
    },
    handleShelve(record) {
      let strOpen = '确定要启用所选数据?';
      let strClose = '确定要禁用所选数据?';
      let formData = { ...record };
      let that = this;
      this.$confirm({
        title: record.statusBl ? '数据上架' : '数据下架',
        content: record.statusBl ? strOpen : strClose,
        onOk() {
          formData.status = record.statusBl ? '0' : '1';
          that.$http
            .post(
              process.env.VUE_APP_CMS_CONTENT + '/cont/pubpage/handleShelve',
              formData,
              { headers: { 'Content-Type': 'application/json; charset=utf-8' } }
            )
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
                record.statusBl = !record.statusBl;
              }
            });
        },
        onCancel() {
          record.statusBl = !record.statusBl;
        }
      });
      console.log(record);
    },
    handleEdit(id) {
      this.$router.push('/contentManage/pubPage/pageEdit/PubPageEdit?id=' + id);
    }
  }
};
</script>
<style lang="less" scoped>
/** Button按钮间距 */
.ant-btn {
  margin-left: 3px;
}

.ant-card-body .table-operator {
  margin-bottom: 18px;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 15px;
  padding-bottom: 15px;
}

.anty-row-operator button {
  margin: 0 5px;
}

.ant-btn-danger {
  background-color: #ffffff;
}

.ant-modal-cust-warp {
  height: 100%;
}

.ant-modal-cust-warp .ant-modal-body {
  height: calc(100% - 110px) !important;
  overflow-y: auto;
}

.ant-modal-cust-warp .ant-modal-content {
  height: 90% !important;
  overflow-y: hidden;
}
</style>
